<section class="section-one">
    <div class="container">
        <p class="headerText">Project data is not available please download from live DB</p>
        <button class="home-button" (click)="syncProjectData()"><mat-icon
                class="margin-right-4">cloud_download</mat-icon></button>
    </div>
</section>